import React from 'react'

export default function GoogleMap() {
  return (
    <section className="relative w-full h-[200px] sm:h-[350px] max-h-[200px] sm:max-h-[350px] overflow-hidden border-t border-silver-400 bg-silver-300">
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d65699.76733512785!2d11.610186515959887!3d55.64347611077323!2m3!1f0!2f0!3f0!2m3!1i1024!2i768!4f13.1!3m3!1m2!1s0x46527d3b284d578d%3A0x6e33cd36137cb4fd!2zSlAgU3TDpWwgb2cgUsO4ciBBcFM!5e1!3m2!1sen!2sdk!4v1780060727927!5m2!1sen!2sdk" width="600" height="450" style={{ border: 0 }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="JP Stål og Rør ApS - Google Maps" className="block w-full h-full" />
    </section>
  )
}
